import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import RadioMenu from './RadioMenu';
import ClientProvider from './client';
export default createDemo(import.meta.url, RadioMenu, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/menus/demos/radio/RadioMenu.tsx",
    "fileName": "RadioMenu.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Paper from '@mui/material/Paper';\nimport MenuList from '@mui/material/MenuList';\nimport MenuItem from '@mui/material/MenuItem';\nimport ListItemText from '@mui/material/ListItemText';\nimport ListItemIcon from '@mui/material/ListItemIcon';\nimport RadioButtonChecked from '@mui/icons-material/RadioButtonChecked';\nimport RadioButtonUnchecked from '@mui/icons-material/RadioButtonUnchecked';\n\nconst options = ['Name', 'Date modified', 'Size'];\n\nexport default function RadioMenu() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [selected, setSelected] = React.useState('Name');\n\n  return (\n    <Paper sx={{ width: 320, maxWidth: '100%' }}>\n      <MenuList>\n        {options.map((option) => (\n          <MenuItem\n            key={option}\n            role=\"menuitemradio\"\n            selected={selected === option}\n            onClick={() => setSelected(option)}\n          >\n            <ListItemIcon>\n              {selected === option ? (\n                <RadioButtonChecked fontSize=\"small\" />\n              ) : (\n                <RadioButtonUnchecked fontSize=\"small\" />\n              )}\n            </ListItemIcon>\n            <ListItemText>{option}</ListItemText>\n          </MenuItem>\n        ))}\n      </MenuList>\n    </Paper>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 38,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Paper from '@mui/material/Paper';\nimport MenuList from '@mui/material/MenuList';\nimport MenuItem from '@mui/material/MenuItem';\nimport ListItemText from '@mui/material/ListItemText';\nimport ListItemIcon from '@mui/material/ListItemIcon';\nimport RadioButtonChecked from '@mui/icons-material/RadioButtonChecked';\nimport RadioButtonUnchecked from '@mui/icons-material/RadioButtonUnchecked';\n\nconst options = ['Name', 'Date modified', 'Size'];\n\nexport default function RadioMenu() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [selected, setSelected] = React.useState('Name');\n\n  return (\n    <Paper sx={{ width: 320, maxWidth: '100%' }}>\n      <MenuList>\n        {options.map((option) => (\n          <MenuItem\n            key={option}\n            role=\"menuitemradio\"\n            selected={selected === option}\n            onClick={() => setSelected(option)}\n          >\n            <ListItemIcon>\n              {selected === option ? (\n                <RadioButtonChecked fontSize=\"small\" />\n              ) : (\n                <RadioButtonUnchecked fontSize=\"small\" />\n              )}\n            </ListItemIcon>\n            <ListItemText>{option}</ListItemText>\n          </MenuItem>\n        ))}\n      </MenuList>\n    </Paper>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 38,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Paper",
      "@mui/material/MenuList",
      "@mui/material/MenuItem",
      "@mui/material/ListItemText",
      "@mui/material/ListItemIcon",
      "@mui/icons-material/RadioButtonChecked",
      "@mui/icons-material/RadioButtonUnchecked"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
